import './modules/script';
import './modules/menu';
import './modules/sliders';
import './modules/language-switcher';


// WEBPACK FOOTER //
// ./assets/js/src/index.js